import { useMutation } from 'libs/query'
import { useTranslation } from 'libs/i18n'
import { useAxiosPrivate, useToast } from 'shared/hooks'
import { apiRoutes } from 'config/apiRoutes'

type UseExportSaleMutation = {
	onSuccess: ({ data }: { data: any }) => void
	onSettled: () => void
}
export const useExportSaleMutation = ({ onSuccess, onSettled }: UseExportSaleMutation) => {
	const { t } = useTranslation()
	const axiosPrivate = useAxiosPrivate()

	const { mutate: exportMutation, isPending: isExportLoading } = useMutation({
		mutationFn: ({
			checkedSales,
			chosenExportFormat
		}: {
			checkedSales: number[]
			chosenExportFormat: number | string | null
		}) => {
			return axiosPrivate.post(apiRoutes.salesExport, {
				format: chosenExportFormat,
				ids: checkedSales
			})
		},
		onSuccess: (res) => {
			onSuccess(res)

			useToast({
				type: 'success',
				message: t('Export succeeded')
			})()
		},
		onError: () => {
			useToast({
				type: 'error',
				message: t('Something went wrong')
			})()
		},
		onSettled: () => {
			onSettled()
		}
	})

	return {
		exportMutation,
		isExportLoading
	}
}
